import React from 'react';
import PropTypes from 'prop-types';
import Interweave from 'interweave';
import * as StyledSubpage from './subpage.styles';
import { H1, Container } from '../../components/base';
import pageWrapper from '../../hoc/pageWrapper';
import { RichTextStyleWrapper } from '../../components/richTextStyleWrapper/richTextStyleWrapper';

const Subpage = ({ page }) => {
	const { Content } = page.Values;

	return (
		<StyledSubpage.Wrapper>
			<Container>
				<StyledSubpage.Content>
					<H1 marginBottom="3rem">{page.Name}</H1>
					<RichTextStyleWrapper>
						<Interweave allowAttributes content={Content} />
					</RichTextStyleWrapper>
				</StyledSubpage.Content>
			</Container>
		</StyledSubpage.Wrapper>
	);
};

Subpage.propTypes = {
	page: PropTypes.object,
};

Subpage.defaultProps = {
	page: null,
};

export default pageWrapper(Subpage);
